import React from "react";
//#region types
import { CompanyTodoCountBadgeProps } from "models/propTypes/allCompaniesPropTypes";
import { StyleEnums } from "models/enums";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { RoundedIcon } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

/** Thousands as whole "6k", rounded to the nearest thousand, so the count fits the circle; the exact count is in the title. */
const formatCount = (count: number) => (count < 1000 ? count.toString() : `${Math.round(count / 1000)}k`);

/** The company's To-do count in a circle: red when any are overdue, a green check badge when there is nothing left. */
const CompanyTodoCountBadge: React.FC<CompanyTodoCountBadgeProps> = (props) => {
  const { count, overdue } = props;
  const done = count === 0;

  if (done)
    return (
      <RoundedIcon icon={IconDefinitionConstants.WCheck} displayType={StyleEnums.DisplayType.Success} size="small" />
    );

  return (
    <div
      className={clsx(cssExports.companyTodoCountBadge, overdue ? cssExports.companyTodoCountBadgeOverdue : undefined)}
      title={count >= 1000 ? LocalizationHelperInstance.getFormattedNumber(count) : undefined}
    >
      {formatCount(count)}
    </div>
  );
};

export default CompanyTodoCountBadge;
